import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

function AdminRestaurantBooking() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); 

  const fetchBookings = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("booking")
      .select("*")
      .order("date", { ascending: true });
    if (error) console.error(error);
    else setBookings(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentBookings = bookings.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(bookings.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const cancelBooking = async (id) => {
    const { error } = await supabase.from("booking").delete().eq("id", id);
    if (error) alert("Erreur lors de la suppression");
    else fetchBookings();
  };

  const markBooked = async (id) => {
    const { error } = await supabase
      .from("booking")
      .update({ status: "booked" })
      .eq("id", id);
    if (error) alert("Erreur lors de la mise à jour");
    else fetchBookings();
  };

  if (loading) return <p>Chargement...</p>;

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Gestion des réservations</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item" style={{color: "#0063cc"}}>Tables</li>
            <li className="breadcrumb-item active" aria-current="page">Réservations</li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Liste des réservations</h4>
              <div className="table-responsive custom-scroll">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Nom</th>
                      <th>Email</th>
                      <th>Téléphone</th>
                      <th>Date</th>
                      <th>Heure</th>
                      <th>Nombre de personnes</th>
                      <th>Message</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBookings.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center">
                          Aucune réservation trouvée.
                        </td>
                      </tr>
                    ) : (
                      currentBookings.map((b) => (
                        <tr key={b.id}>
                          <td>{b.name}</td>
                          <td>{b.email}</td>
                          <td>{b.phone}</td>
                          <td>{b.date}</td>
                          <td>{b.time}</td>
                          <td>{b.number_of_people}</td>
                          <td>{b.message}</td>
                          <td>{b.status}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-success mr-2"
                              onClick={() => markBooked(b.id)}
                              disabled={b.status === "booked"}
                            >
                              Réserver
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => cancelBooking(b.id)}
                            >
                              Annuler
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              
              {bookings.length > 0 && (
                <nav aria-label="Page navigation" className="mt-4">
                  <ul className="pagination justify-content-center">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={goToPreviousPage} aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                      </button>
                    </li>
                    
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                      <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => paginate(page)}>
                          {page}
                        </button>
                      </li>
                    ))}
                    
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={goToNextPage} aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminRestaurantBooking;